import { COST_ARTICLES, type CostArticlesResponse } from '@epc/contracts';
import { queryOptions, useQuery } from '@tanstack/react-query';
import { api } from './api';

export const costArticlesQuery = queryOptions({
  queryKey: ['cost-articles'],
  queryFn: () => api<CostArticlesResponse>('/cost-articles'),
  staleTime: 60_000,
});

/** Статьи расходов для выбора в формах: двенадцать утверждённых и утверждённые по запросу (БМ-15) */
export function useCostArticles(): string[] {
  const q = useQuery(costArticlesQuery);
  return q.data?.active ?? [...COST_ARTICLES];
}
